import { connect } from 'react-redux'
import { actions, dispatch } from '@opallabs/wormhole'
import { buildPatchParams } from './helpers'
import { InlineApproval as InlineApprovalComponent } from '.'

const mapDispatchToProps = () => ({
  updateApproval: (params, getWorkflow) => {
    dispatch(actions.updatePhaseItem(buildPatchParams(params), getWorkflow))
  },
})

const InlineApproval = connect(
  null,
  mapDispatchToProps
)(InlineApprovalComponent)

export default InlineApproval
